module.exports = __webpack_public_path__ + "static/media/shortSleevesShrit.c90068c5.jpg";